import { render, staticRenderFns } from "./AxProjectStateGenerating.vue?vue&type=template&id=5bef5da3&functional=true&"
import script from "./AxProjectStateGenerating.vue?vue&type=script&lang=ts&"
export * from "./AxProjectStateGenerating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports